import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Linkedin, MessageCircle } from 'lucide-react';

const ScrollLink = ({ to, children, className }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const sectionId = to.replace('/#', '');

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <a href={to} onClick={handleClick} className={className}>
      {children}
    </a>
  );
};

const FOOTER_AI_PROMPT = encodeURIComponent(
  "I'm a buyer at a food import, distribution or retail company evaluating ALL-FOOD as an Italian food sourcing partner. Read https://www.all-food.it and give me a plain-English read on: what ALL-FOOD actually does and for whom, which product categories and markets they cover, and what they handle versus what stays with me as the importer. Then ask me 3 questions about my situation (market, channel, volumes, categories, timeline) so you can tell me whether ALL-FOOD is a strong fit, a stretch, or a mismatch. Be honest if it's a mismatch. End with the 3 questions I should ask ALL-FOOD before placing a first order."
);

const FOOTER_AI_SERVICES = [
  {
    name: 'ChatGPT',
    url: `https://chatgpt.com/?q=${FOOTER_AI_PROMPT}`,
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="#ffffff">
        <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" />
      </svg>
    ),
  },
  {
    name: 'Claude',
    url: `https://claude.ai/new?q=${FOOTER_AI_PROMPT}`,
    icon: (
      <svg viewBox="0 0 1200 1200" className="w-10 h-10" fill="#D97757">
        <path d="M 233.959793 800.214905 L 468.644287 668.536987 L 472.590637 657.100647 L 468.644287 650.738403 L 457.208069 650.738403 L 417.986633 648.322144 L 283.892639 644.69812 L 167.597321 639.865845 L 54.926208 633.825623 L 26.577238 627.785339 L 3.3e-05 592.751709 L 2.73832 575.27533 L 26.577238 559.248352 L 60.724873 562.228149 L 136.187973 567.382629 L 249.422867 575.194763 L 331.570496 580.026978 L 453.261841 592.671082 L 472.590637 592.671082 L 475.328857 584.859009 L 468.724915 580.026978 L 463.570557 575.194763 L 346.389313 495.785217 L 219.543671 411.865906 L 153.100723 363.543762 L 117.181267 339.060425 L 99.060455 316.107361 L 91.248367 266.01355 L 123.865784 230.093994 L 167.677887 233.073853 L 178.872513 236.053772 L 223.248367 270.201477 L 318.040283 343.570496 L 441.825592 434.738342 L 459.946411 449.798706 L 467.194672 444.64447 L 468.080597 441.020203 L 459.946411 427.409485 L 392.617493 305.718323 L 320.778564 181.932983 L 288.80542 130.630859 L 280.348999 99.865845 C 277.369171 87.221436 275.194641 76.590698 275.194641 63.624268 L 312.322174 13.20813 L 332.8591 6.604126 L 382.389313 13.20813 L 403.248352 31.328979 L 434.013519 101.71814 L 483.865753 212.537048 L 561.181274 363.221497 L 583.812134 407.919434 L 595.892639 449.315491 L 600.40271 461.959839 L 608.214783 461.959839 L 608.214783 454.711609 L 614.577271 369.825623 L 626.335632 265.61084 L 637.771851 131.516846 L 641.718201 93.745117 L 660.402832 48.483276 L 697.530334 24.000122 L 726.52356 37.852417 L 750.362549 72 L 747.060486 94.067139 L 732.886047 186.201416 L 705.100708 330.52356 L 686.979919 427.167847 L 697.530334 427.167847 L 709.61084 415.087341 L 758.496704 350.174561 L 840.644348 247.490051 L 876.885925 206.738342 L 919.167847 161.71814 L 946.308838 140.29541 L 997.61084 140.29541 L 1035.38269 196.429626 L 1018.469849 254.416199 L 965.637634 321.422852 L 921.825562 378.201538 L 859.006714 462.765259 L 819.785278 530.41626 L 823.409424 535.812073 L 832.75177 534.92627 L 974.657776 504.724915 L 1051.328979 490.872559 L 1142.818848 475.167786 L 1184.214844 494.496582 L 1188.724854 514.147644 L 1172.456421 554.335693 L 1074.604126 578.496765 L 959.838989 601.449829 L 788.939636 641.879272 L 786.845764 643.409485 L 789.261841 646.389343 L 866.255127 653.637634 L 899.194702 655.409424 L 979.812134 655.409424 L 1129.932861 666.604187 L 1169.154419 692.537109 L 1192.671265 724.268677 L 1188.724854 748.429688 L 1128.322144 779.194641 L 1046.818848 759.865845 L 856.590759 714.604126 L 791.355774 698.335754 L 782.335693 698.335754 L 782.335693 703.731567 L 836.69812 756.885986 L 936.322205 846.845581 L 1061.073975 962.81897 L 1067.436279 991.490112 L 1051.409424 1014.120911 L 1034.496704 1011.704712 L 924.885986 929.234924 L 882.604126 892.107544 L 786.845764 811.48999 L 780.483276 811.48999 L 780.483276 819.946289 L 802.550415 852.241699 L 919.087341 1027.409424 L 925.127625 1081.127686 L 916.671204 1098.604126 L 886.469849 1109.154419 L 853.288696 1103.114136 L 785.073914 1007.355835 L 714.684631 899.516785 L 657.906067 802.872498 L 650.979858 806.81897 L 617.476624 1167.704834 L 601.771851 1186.147705 L 565.530212 1200 L 535.328857 1177.046997 L 519.302124 1139.919556 L 535.328857 1066.550537 L 554.657776 970.792053 L 570.362488 894.68457 L 584.536926 800.134277 L 592.993347 768.724976 L 592.429626 766.630859 L 585.503479 767.516968 L 514.22821 865.369263 L 405.825531 1011.865906 L 320.053711 1103.677979 L 299.516815 1111.812256 L 263.919525 1093.369263 L 267.221497 1060.429688 L 287.114136 1031.114136 L 405.825531 880.107361 L 477.422913 786.52356 L 523.651062 732.483276 L 523.328918 724.671265 L 520.590698 724.671265 L 205.288605 929.395935 L 149.154434 936.644409 L 124.993355 914.01355 L 127.973183 876.885986 L 139.409409 864.80542 L 234.201385 799.570435 L 233.879227 799.8927 Z" />
      </svg>
    ),
  },
  {
    name: 'Perplexity',
    url: `https://www.perplexity.ai/?q=${FOOTER_AI_PROMPT}`,
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="#20808D" fillRule="evenodd">
        <path d="M19.785 0v7.272H22.5V17.62h-2.935V24l-7.037-6.194v6.145h-1.091v-6.152L4.392 24v-6.465H1.5V7.188h2.884V0l7.053 6.494V.19h1.09v6.49L19.786 0zm-7.257 9.044v7.319l5.946 5.234V14.44l-5.946-5.397zm-1.099-.08l-5.946 5.398v7.235l5.946-5.234V8.965zm8.136 7.58h1.844V8.349H13.46l6.105 5.54v2.655zm-8.982-8.28H2.59v8.195h1.8v-2.576l6.192-5.62zM5.475 2.476v4.71h5.115l-5.115-4.71zm13.219 0l-5.115 4.71h5.115v-4.71z" />
      </svg>
    ),
  },
  {
    name: 'Google AI',
    url: `https://www.google.com/search?q=${FOOTER_AI_PROMPT}&udm=50`,
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="url(#footer-gemini-gradient)">
        <defs>
          <linearGradient id="footer-gemini-gradient" x1="0" y1="24" x2="24" y2="0" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#4285F4" />
            <stop offset="50%" stopColor="#9B72CB" />
            <stop offset="100%" stopColor="#F6AD01" />
          </linearGradient>
        </defs>
        <path d="M11.04 21.16a.502.502 0 00.975 0c.172-.685.397-1.351.677-2.003a14.145 14.145 0 013.001-4.45 14.113 14.113 0 016.453-3.678.503.503 0 000-.975 13.245 13.245 0 01-2.003-.678 14.147 14.147 0 01-4.45-3.001 14.111 14.111 0 01-3.678-6.452.503.503 0 00-.975 0 14.134 14.134 0 01-3.679 6.452 14.155 14.155 0 01-4.45 3.001c-.65.28-1.318.505-2.002.678a.502.502 0 000 .975c.684.172 1.35.397 2.002.677a14.147 14.147 0 014.45 3.001 14.112 14.112 0 013.679 6.453z" />
      </svg>
    ),
  },
  {
    name: 'Grok',
    url: `https://grok.com/?q=${FOOTER_AI_PROMPT}`,
    icon: (
      <svg viewBox="0 0 24 24" className="w-10 h-10" fill="#ffffff" fillRule="evenodd">
        <path d="M20.5,12 A8.5,8.5 0 1,0 3.5,12 A8.5,8.5 0 1,0 20.5,12 Z M18.1,12 A6.1,6.1 0 1,0 5.9,12 A6.1,6.1 0 1,0 18.1,12 Z M3.2,20.8 L12.92,12.92 L20.8,3.2 L11.08,11.08 Z" />
      </svg>
    ),
  },
];

const FooterAskAi = () => (
  <div className="text-center pb-10 mb-8 border-b border-stone-800" data-testid="footer-ask-ai">
    <h3 className="text-white font-bold tracking-wide uppercase text-sm mb-5" data-testid="footer-ask-ai-heading">
      Ask AI about ALL-FOOD
    </h3>
    <div className="flex items-center justify-center gap-8" data-testid="footer-ask-ai-buttons">
      {FOOTER_AI_SERVICES.map((service) => (
        <a
          key={service.name}
          href={service.url}
          target="_blank"
          rel="noopener nofollow"
          aria-label={`Ask ${service.name} about ALL-FOOD`}
          title={`Ask ${service.name} about ALL-FOOD`}
          data-testid={`footer-ask-ai-btn-${service.name.toLowerCase().replace(/\s/g, '-')}`}
          className="transition-all duration-200 hover:scale-110 hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white rounded"
        >
          <span aria-hidden="true">{service.icon}</span>
        </a>
      ))}
    </div>
  </div>
);

const Footer = () => {
  const columnHeading = "text-white font-semibold tracking-wide uppercase text-xs mb-3";
  const linkClass = "text-stone-300 hover:text-white transition-colors duration-200 text-sm";

  return (
    <footer className="bg-stone-900 text-white py-10 px-6" data-testid="site-footer">
      <div className="container mx-auto max-w-6xl">
        <FooterAskAi />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-12 gap-8 mb-8 text-sm">
          {/* 1. Brand */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2" data-testid="footer-brand">
            <Link to="/" className="inline-block">
              <img
                src="/api/img/allfood-logo-32.webp"
                srcSet="/api/img/allfood-logo-32.webp 1x, /api/img/allfood-logo-64.webp 2x"
                alt="ALL-FOOD Logo"
                className="h-8 w-8 mb-3 brightness-0 invert"
                width="32"
                height="32"
                loading="lazy"
              />
            </Link>
            <p className="text-stone-300 text-sm leading-relaxed">
              Your trusted Italian export office and sourcing partner.
            </p>
          </div>

          <nav aria-label="Footer" className="contents">
            {/* 2. Products */}
            <div className="lg:col-span-2" data-testid="footer-products">
              <h3 className={columnHeading}>Products</h3>
              <ul className="space-y-2">
                <li><Link to="/categories/italian-pasta" className={linkClass} data-testid="footer-italian-pasta-link">Pasta</Link></li>
                <li><Link to="/categories/italian-olive-oil" className={linkClass} data-testid="footer-italian-olive-oil-link">Olive Oil</Link></li>
                <li><Link to="/categories/italian-pastry-bakery" className={linkClass} data-testid="footer-italian-pastry-bakery-link">Pastry &amp; Bakery</Link></li>
                <li><Link to="/categories/italian-cheese" className={linkClass} data-testid="footer-italian-cheese-link">Cheese</Link></li>
                <li><Link to="/categories" className={linkClass} data-testid="footer-categories-hub-link">All categories →</Link></li>
              </ul>
            </div>

            {/* 3. Services */}
            <div className="lg:col-span-2" data-testid="footer-services">
              <h3 className={columnHeading}>Services</h3>
              <ul className="space-y-2">
                <li><Link to="/private-label" className={linkClass} data-testid="footer-private-label-link">Private Label</Link></li>
                <li><Link to="/for-producers" className={linkClass} data-testid="footer-for-producers-link">For Producers</Link></li>
                <li><Link to="/services" className={linkClass} data-testid="footer-all-services-link">All services →</Link></li>
              </ul>
              <h3 className={`${columnHeading} mt-6`}>Tools</h3>
              <ul className="space-y-2">
                <li className="whitespace-nowrap"><Link to="/tools/italian-food-import-cost-calculator" className={linkClass} data-testid="footer-import-cost-calculator-link">Import Cost Calculator →</Link></li>
                <li className="whitespace-nowrap"><Link to="/glossary" className={linkClass} data-testid="footer-import-glossary-link">Import Glossary →</Link></li>
              </ul>
            </div>

            {/* 4. Markets */}
            <div className="lg:col-span-2" data-testid="footer-markets">
              <h3 className={columnHeading}>Markets</h3>
              <ul className="space-y-2 whitespace-nowrap">
                <li><Link to="/markets" className={linkClass} data-testid="footer-markets-hub-link">All markets</Link></li>
                <li><Link to="/markets/usa" className={linkClass} data-testid="footer-market-usa-link">USA</Link></li>
                <li><Link to="/markets/europe" className={linkClass} data-testid="footer-market-europe-link">Europe</Link></li>
                <li><Link to="/markets/uk" className={linkClass} data-testid="footer-market-uk-link">UK</Link></li>
                <li><Link to="/markets/canada" className={linkClass} data-testid="footer-market-canada-link">Canada</Link></li>
                <li><Link to="/markets/australia" className={linkClass} data-testid="footer-market-australia-link">Australia</Link></li>
                <li><Link to="/markets/middle-east" className={linkClass} data-testid="footer-market-middle-east-link">Middle East</Link></li>
                <li><Link to="/markets/south-america" className={linkClass} data-testid="footer-market-south-america-link">South America</Link></li>
              </ul>
            </div>

            {/* 5. Company */}
            <div className="lg:col-span-2" data-testid="footer-company">
              <h3 className={columnHeading}>Company</h3>
              <ul className="space-y-2">
                <li><ScrollLink to="/#about" className={linkClass}>About Us</ScrollLink></li>
                <li><ScrollLink to="/#why-us" className={linkClass}>Why Us</ScrollLink></li>
                <li><ScrollLink to="/#partners" className={linkClass}>Our Partners</ScrollLink></li>
                <li><Link to="/case-studies" className={linkClass} data-testid="footer-case-studies-link">Case Studies</Link></li>
                <li><Link to="/blog" className={linkClass} data-testid="footer-blog-link">Blog</Link></li>
                <li><ScrollLink to="/#contact" className={linkClass}>Contact</ScrollLink></li>
              </ul>
            </div>
          </nav>

          {/* 6. Contact */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2" data-testid="footer-contact">
            <h3 className={columnHeading}>Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="mailto:global@all-food.it" className={linkClass}>
                  global@all-food.it
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/393283915713?text=Hello,%20I'm%20interested%20in%20learning%20more%20about%20ALL-FOOD's%20Italian%20export%20services."
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${linkClass} inline-flex items-center space-x-1`}
                >
                  <MessageCircle size={14} />
                  <span>WhatsApp</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/all-food-s-r-l/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${linkClass} inline-flex items-center space-x-1`}
                >
                  <Linkedin size={14} />
                  <span>LinkedIn</span>
                </a>
              </li>
            </ul>
            <div className="border-t border-stone-700 my-4"></div>
            <div className="text-stone-300 text-sm space-y-1">
              <p>ALL-FOOD SRL</p>
              <p className="whitespace-nowrap">Piazza Arnolfo di Cambio, 25</p>
              <p className="whitespace-nowrap">53034 Colle di Val d'Elsa (SI)</p>
              <p><a href="tel:+393283915713" className={linkClass}>+39 328 391 5713</a></p>
              <p>P.I./C.F. 01587130525</p>
              <p>SDI: M5UXCR1</p>
              <p><a href="mailto:all-food@pec.it" className={linkClass}>all-food@pec.it</a></p>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-4 text-center text-stone-400 text-xs">
          <div className="flex justify-center gap-4 mb-2">
            <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors">Privacy Policy</Link>
            <Link to="/informativa-privacy-clienti-fornitori" className="hover:text-blue-400 transition-colors" data-testid="footer-informativa-privacy-link">Informativa Privacy</Link>
            <Link to="/cookie-policy" className="hover:text-blue-400 transition-colors">Cookie Policy</Link>
            <Link to="/terms-of-service" className="hover:text-blue-400 transition-colors">Terms of Service</Link>
            <Link to="/de/italienische-lebensmittel-grosshandel" className="hover:text-blue-400 transition-colors" data-testid="footer-german-link">Deutsch</Link>
          </div>
          <p>&copy; {new Date().getFullYear()} ALL-FOOD. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
